export enum SubscriptionRoles {
  'Free Trial' = 0,
  'Single Host' = 1,
  'Single Host+' = 2,
  '2-Hosts' = 3,
  '4-Hosts' = 4,
  '15-Hosts' = 5,
}
